/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Cv_Review_Category_ClarityInputs */

const en_pdf_cv_review_category_clarity = /** @type {(inputs: Pdf_Cv_Review_Category_ClarityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language & Grammar`)
};

const de_pdf_cv_review_category_clarity = /** @type {(inputs: Pdf_Cv_Review_Category_ClarityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache & Grammatik`)
};

/**
* | output |
* | --- |
* | "Language & Grammar" |
*
* @param {Pdf_Cv_Review_Category_ClarityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pdf_cv_review_category_clarity = /** @type {((inputs?: Pdf_Cv_Review_Category_ClarityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Cv_Review_Category_ClarityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pdf_cv_review_category_clarity(inputs)
	return en_pdf_cv_review_category_clarity(inputs)
});